import React, { useEffect, useState } from 'react'
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Switch, TextField, Typography } from '@mui/material'
import { useStyles } from './Application.styles'
import { COLOR_PRIMARY } from '../../routes/color-constants'
import { useTranslation } from 'react-i18next'
import { Product } from '../../modules/product/models/Product'


type ProductProps = {
  data: Product[]
  handleModalClose: () => void
  selectedProduct: Product[]
  setSelectedProduct: (p: Product[]) => void
  handleFav: (p: Product) => void
  favList: string[]
  deleteFav: (p: Product) => void
}


type ProductChecked = {
  product: Product
  checked: boolean
  index: number
}


export const ModalProducts = (props: ProductProps) => {
  const classes = useStyles({ color: COLOR_PRIMARY })
  const { t, i18n } = useTranslation()
  const [searcher, setSearcher] = useState<string>('')
  const [selectedHere, setSelectedHere] = useState<Product[]>(props.selectedProduct)
  const [favActive, setFavActive] = useState<boolean>(false)

  // FIX: Eliminado el estado local `favList` — se usa props.favList directamente
  // para que los botones reflejen siempre el estado real del padre.


  const getProductChecked = () => {
    let productCheckedArr: ProductChecked[] = []
    if (props.selectedProduct.length === 0) {
      props.data.forEach((p, i) =>
        productCheckedArr.push({ index: i, checked: false, product: p })
      )
    } else {
      props.data.forEach((p, i) => {
        const selected = props.selectedProduct.some((sp) => sp.id === p.id)
        productCheckedArr.push({ index: i, checked: selected, product: p })
      })
    }
    return productCheckedArr
  }


  const [productChecked, setProductChecked] = useState<ProductChecked[]>(getProductChecked())
  const [filteredProducts, setFilteredProducts] = useState<ProductChecked[]>(productChecked)
  const [AllFilteredProducts, setAllFilteredProducts] = useState<ProductChecked[]>(getProductChecked())


  const applyFavFilter = (list: ProductChecked[], currentFavActive: boolean): ProductChecked[] => {
    // FIX: Eliminado el parámetro currentFavList, ahora usa props.favList directamente
    if (!currentFavActive) return list
    return list.filter((ap) => props.favList.includes(ap.product.idOdoo))
  }


  const handleSave = () => {
    props.setSelectedProduct && props.setSelectedProduct(selectedHere)
    props.handleModalClose()
  }


  const getNameByLanguage = (p: Product) => {
    if (i18n.language === 'es') {
      return p.nameES
    }
    return p.nameEN
  }


  useEffect(() => {
    // FIX: Ahora usa props.favList directamente, sin necesidad de setFavList
    if (favActive) {
      const filtered = AllFilteredProducts.filter((ap) =>
        props.favList.includes(ap.product.idOdoo)
      )
      setFilteredProducts(filtered)
    }
  }, [props.favList])


  const handleChangeCheck = (product: ProductChecked) => {
    let aux = [...selectedHere]
    let index = aux.map((p) => p.id).indexOf(product.product.id)


    if (index !== -1) {
      aux.splice(index, 1)
      setSelectedHere(aux)
    } else {
      aux.push(product.product)
      setSelectedHere(aux)
    }


    let checkedBefore = productChecked.filter((p) => p.checked)


    let ch = [...productChecked]
    let indexOf = ch.map((c) => c.product.id).indexOf(product.product.id)


    if (indexOf !== -1) {
      ch[indexOf] = { ...ch[indexOf], checked: !ch[indexOf].checked }
    }


    setProductChecked(ch)


    let checkedAfter = ch.filter((p) => p.checked)


    if (checkedBefore.length === 0 && checkedAfter.length > 0) {
      const type = product.product.typeForm
      const filtered = props.data.filter((d) => d.typeForm === type)
      let productCheckedArr: ProductChecked[] = filtered.map((p, i) => ({
        index: i,
        checked: false,
        product: p,
      }))


      setAllFilteredProducts(productCheckedArr)


      if (searcher !== '') {
        const bySearch = productCheckedArr.filter((t) =>
          getNameByLanguage(t.product).toLowerCase().includes(searcher.toLowerCase())
        )
        // FIX: applyFavFilter ya no recibe favList como parámetro
        setFilteredProducts(applyFavFilter(bySearch, favActive))
      } else {
        setFilteredProducts(applyFavFilter(productCheckedArr, favActive))
      }
    } else if (checkedBefore.length > 0 && checkedAfter.length === 0) {
      if (searcher !== '') {
        const filtered2 = props.data.filter((p) =>
          getNameByLanguage(p).toLowerCase().includes(searcher.toLowerCase()) ||
          p.reference.includes(searcher)
        )
        const fullList = getProductChecked().filter((pc) =>
          filtered2.some((p) => p.id === pc.product.id)
        )
        setAllFilteredProducts(getProductChecked())
        // FIX: applyFavFilter ya no recibe favList como parámetro
        setFilteredProducts(applyFavFilter(fullList, favActive))
      } else {
        let productCheckedArr: ProductChecked[] = []
        props.data.forEach((p, i) =>
          productCheckedArr.push({ index: i, checked: false, product: p })
        )
        setAllFilteredProducts(productCheckedArr)
        setFilteredProducts(applyFavFilter(productCheckedArr, favActive))
      }
    }
  }


  const filterProducts = (searchText: string) => {
    const source =
      productChecked.filter((p) => p.checked).length === 0
        ? props.data
        : AllFilteredProducts.map((a) => a.product)


    const filtered2 = source.filter(
      (p) =>
        getNameByLanguage(p).toLowerCase().includes(searchText.toLowerCase()) ||
        p.reference.includes(searchText)
    )


    const result = getProductChecked().filter((pc) =>
      filtered2.some((p) => p.id === pc.product.id)
    )


    // FIX: applyFavFilter ya no recibe favList como parámetro
    setFilteredProducts(applyFavFilter(result, favActive))
  }


  const handleSearch = (e: any) => {
    const searchText = e.target.value
    setSearcher(searchText)
    filterProducts(searchText)
  }


  const onlyFav = () => {
    if (!favActive) {
      // FIX: Usa props.favList directamente en lugar del estado local favList
      const filtered = AllFilteredProducts.filter((ap) =>
        props.favList.includes(ap.product.idOdoo)
      )
      setFilteredProducts(filtered)
    } else {
      if (searcher !== '') {
        filterProducts(searcher)
      } else {
        setFilteredProducts(AllFilteredProducts)
      }
    }


    setFavActive(!favActive)
  }


  useEffect(() => {
    setProductChecked(getProductChecked())
    filterProducts(searcher)
  }, [])


  const isChecked = (pr: Product) => {
    return selectedHere.map((p) => p.id).includes(pr.id)
  }


  return (
    <>
      <Grid className={classes.modalProduct} container>
        <Grid xs={12} className={classes.modalBackground}>
          <Typography
            variant={'h4'}
            align="left"
            className={classes.titleModal}
            style={{ marginLeft: '2rem', marginRight: '30px' }}>
            {t('productSelection')}
          </Typography>
          <div style={{ marginLeft: '2rem', fontWeight: 'bold', marginRight: '30px' }}>
            {t('selectYourProduct')}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              flexGrow: 1,
              marginTop: '-6rem',
            }}>
            <FormControlLabel
              style={{ marginLeft: '75px' }}
              control={
                <Switch
                  onChange={onlyFav}
                  color='primary'
                  style={{ color: '#FAFAFA' }}
                  checked={favActive}
                />
              }
              label={t('fav')}
            />
          </div>
        </Grid>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            flexGrow: 1,
            marginTop: '-6rem',
            marginRight: '30px',
          }}>
          <TextField
            id="outlined"
            label={t('search')}
            variant="outlined"
            value={searcher}
            onChange={(e) => handleSearch(e)}
          />
        </div>
        <Grid
          item
          xs={12}
          style={{
            margin: '2rem 2rem 2rem 2rem',
            overflowY: 'scroll',
            height: '50vh',
            overflowX: 'hidden',
          }}>
          <FormGroup>
            {filteredProducts
              .sort((a, b) => a.product.reference.localeCompare(b.product.reference))
              .map((element) => {
                return (
                  <Grid xs={12} key={element.product.id}>
                    <div className={classes.row2}>
                      <Checkbox
                        checked={isChecked(element.product)}
                        onChange={() => handleChangeCheck(element)}
                        style={{ paddingTop: '1px' }}
                      />
                      <div className={classes.titleProductName}>
                        {i18n.language === 'es' ? element.product.nameES : element.product.nameEN}
                      </div>
                      <Button
                        type={'button'}
                        onClick={() =>
                          // FIX: Usa props.favList en lugar del estado local favList
                          !props.favList?.includes(element.product.idOdoo)
                            ? props?.handleFav(element.product)
                            : props?.deleteFav(element.product)
                        }
                        style={{ marginLeft: '10px', height: '25px' }}
                        // FIX: Usa props.favList para determinar el estilo del botón
                        className={
                          props.favList?.includes(element.product.idOdoo)
                            ? classes.button
                            : classes.buttonSecondary
                        }>
                        Fav
                      </Button>
                    </div>
                    <div
                      style={{
                        borderBottom: 'solid',
                        borderWidth: '1px',
                        borderColor: 'grey',
                        marginBottom: '20px',
                        paddingBottom: '20px',
                      }}>
                      <div>
                        <div className={classes.column}>
                          <Grid container>
                            <Grid xs={7}>
                              <div className={classes.row2}>
                                <div className={classes.productType}>{t('typeProduct')}</div>
                                <div>{element.product.type}</div>
                              </div>
                            </Grid>
                            <Grid xs={7}>
                              <div className={classes.row2}>
                                <div className={classes.productType}>{t('reference')}</div>
                                <div>{element.product.reference}</div>
                              </div>
                            </Grid>
                            {element.product.genes !== '' && (
                              <Grid xs={7}>
                                <div className={classes.row2}>
                                  <div className={classes.productType}>{t('genes')}</div>
                                  <div>{element.product.genes}</div>
                                </div>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                      </div>
                    </div>
                  </Grid>
                )
              })}
          </FormGroup>
        </Grid>
        <Grid xs={12} className={classes.buttonsModal}>
          <Button type={'button'} onClick={handleSave} className={classes.button}>
            OK
          </Button>
          <Button
            type={'button'}
            onClick={props.handleModalClose}
            className={classes.buttonSecondary}>
            {t('cancel')}
          </Button>
        </Grid>
      </Grid>
    </>
  )
}